// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2n4h1","importantInfo":"styles_importantInfo__3yN6U"};